import { render, staticRenderFns } from "./AuthRegister.vue?vue&type=template&id=b7b49540"
import script from "./AuthRegister.vue?vue&type=script&lang=js"
export * from "./AuthRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports